export default function resetSelectStyles() {
    return {
        clearIndicator: function () { return ({}); },
        container: function () { return ({}); },
        control: function () { return ({}); },
        dropdownIndicator: function () { return ({}); },
        group: function () { return ({}); },
        groupHeading: function () { return ({}); },
        indicatorsContainer: function () { return ({}); },
        indicatorSeparator: function () { return ({}); },
        input: function () { return ({}); },
        loadingIndicator: function () { return ({}); },
        loadingMessage: function () { return ({}); },
        menu: function () { return ({}); },
        menuList: function (_a) {
            var maxHeight = _a.maxHeight;
            return ({
                maxHeight: maxHeight,
            });
        },
        multiValue: function () { return ({}); },
        multiValueLabel: function () { return ({}); },
        multiValueRemove: function () { return ({}); },
        noOptionsMessage: function () { return ({}); },
        option: function () { return ({}); },
        placeholder: function () { return ({}); },
        singleValue: function () { return ({}); },
        valueContainer: function () { return ({}); },
    };
}
//# sourceMappingURL=resetSelectStyles.js.map